import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import PacingNavigationComponent from './component'

const PathwayNavigationContainer = ({
  handlePathwayNavigation,
  startingIndex,
  tabStatuses,
}) => {
  // TODO: Set active index to most recent pathway visited
  const [activeIndex, setActiveIndex] = useState(startingIndex || 0)
  // TODO: drive these labels from Contentful
  const pathwayTitles = [
    'TRAINING',
    'PATHWAY 1',
    'PATHWAY 2',
    'PATHWAY 3',
    'PATHWAY 4',
  ] // dynamic data

  const handleSquareClick = index => {
    setActiveIndex(index)
    handlePathwayNavigation(index)
  }

  // ensure if the startingIndex is changed after first render, the state variable gets updated
  useEffect(() => {
    if (startingIndex !== activeIndex) {
      setActiveIndex(startingIndex)
    }
  }, [startingIndex])

  return (
    <PacingNavigationComponent
      activeIndex={activeIndex}
      handleSquareClick={handleSquareClick}
      pathwayTitles={pathwayTitles}
      tabStatuses={tabStatuses}
    />
  )
}

PathwayNavigationContainer.propTypes = {
  handlePathwayNavigation: PropTypes.func,
  startingIndex: PropTypes.number,
  tabStatuses: PropTypes.array,
}

export default PathwayNavigationContainer
